import React from "react";
import "./NotificationsContainer.scss";

export interface LzPNotificationsContainer {
    top?: boolean,
    bottom?: boolean,
    left?: boolean,
    center?: boolean,
    right?: boolean,
}

const LzXNotificationsContainer = (props: LzPNotificationsContainer) => {
    let classes = 'lz-notifications-container';

    // Get the vertical alignment of the messages stack (top by default)
    if (props.bottom) {
        classes += ' lz-notifications-container-bottom';
    } else {
        classes += ' lz-notifications-container-top';
    }

    // Get the horizontal alignment of the messages stack (right by default)
    if (props.left) {
        classes += ' lz-notifications-container-left';
    } else if (props.center) {
        classes += ' lz-notifications-container-center';
    } else {
        classes += ' lz-notifications-container-right';
    }

    return (
        <div id="idLzNotificationsContainer" className={classes}></div >
    );
};

export default LzXNotificationsContainer;
